/**
 * @function getAuthHeaders
 * @desc This handles returns the auth headers array, which can be used in making api requests
 */
export const getAuthHeaders = () => {
  const authToken = localStorage.getItem("authToken");
  if (authToken) {
    const headers = {
      "Content-Type": "application/json",
      Authorization: authToken
    };
    return headers;
  } else {
    return null;
  }
};

/**
 * @function getBasicAuthHeadersElastic
 * @desc This handles returns the basic auth headers array for elastic search, which can be used in making api requests
 */
export const getBasicAuthHeadersElastic = () => {
  const headers = {
    Authorization:
      "Basic " +
      btoa(
        process.env.REACT_APP_ELASTIC_USER +
          ":" +
          process.env.REACT_APP_ELASTIC_PASS
      )
  };
  return headers;
};

/**
 * @function getBasicAuthHeaders
 * @description function that returns basic auth headers
 */
export const getBasicAuthHeaders = () => {
  const authToken = btoa(
    `${process.env.REACT_APP_SEARCH_API_KEY}:${process.env.REACT_APP_SEARCH_API_PWD}`
  );

  if (authToken) {
    const headers = {
      Authorization: `Basic ${authToken}`
    };
    return headers;
  }
  return null;
};
